export const FormItem = 'md:min-w-[482px]';